
import { Component, Emit, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class LogoutModal extends Vue {
  name = 'LogoutModal';

  data() {
    return {
    }
  }

  @Emit('close')
  close(event) {
    return event;
  }
}
